import { render, staticRenderFns } from "./D.vue?vue&type=template&id=0208832e"
import script from "./D.vue?vue&type=script&lang=js"
export * from "./D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports